import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({
    name: "", email: "", password: "", dancer_name: "", phone: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }
    setError("");
    setLoading(true);
    const r = await register(form);
    setLoading(false);
    if (r.ok) {
      nav("/welcome");
    } else {
      setError(r.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-16 relative grain">
      <div className="max-w-md w-full">
        <Link to="/" className="flex items-center gap-3 justify-center mb-10" data-testid="register-logo-link">
          <img src={LOGO_URL} alt="" className="h-16 w-16 object-contain drop-shadow-[0_0_12px_rgba(0,229,255,0.5)]" />
          <div className="leading-tight">
            <div className="font-display text-2xl text-chrome">DAZZLIN' DYMES</div>
            <div className="text-[10px] uppercase tracking-[0.32em] text-[#00E5FF]">Join the Family</div>
          </div>
        </Link>

        <div className="card-dark p-8">
          <div className="overline mb-2">Create your parent account</div>
          <h1 className="font-display text-3xl text-chrome uppercase">Sign Up</h1>

          <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="register-form">
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-white/50">Parent Name</label>
              <input type="text" required value={form.name} onChange={update("name")} className="input-line mt-1" placeholder="Jane Doe" data-testid="register-name-input" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-white/50">Dancer's Name (optional)</label>
              <input type="text" value={form.dancer_name} onChange={update("dancer_name")} className="input-line mt-1" placeholder="Aaliyah" data-testid="register-dancer-input" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-white/50">Phone (optional)</label>
              <input type="tel" value={form.phone} onChange={update("phone")} className="input-line mt-1" placeholder="(555) 123-4567" data-testid="register-phone-input" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-white/50">Email</label>
              <input type="email" required value={form.email} onChange={update("email")} className="input-line mt-1" placeholder="you@email.com" data-testid="register-email-input" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-white/50">Password</label>
              <input type="password" required minLength={6} value={form.password} onChange={update("password")} className="input-line mt-1" placeholder="At least 6 characters" data-testid="register-password-input" />
            </div>

            {error && (
              <div className="text-sm text-red-400 border border-red-400/30 bg-red-400/5 rounded px-3 py-2" data-testid="register-error">
                {error}
              </div>
            )}

            <button type="submit" disabled={loading} className="btn-electric w-full" data-testid="register-submit-button">
              {loading ? <Loader2 className="animate-spin" size={16} /> : "Create Account"}
            </button>
          </form>

          <div className="mt-6 text-center text-sm text-white/50">
            Already in?{" "}
            <Link to="/login" className="text-[#00E5FF] hover:text-white" data-testid="register-to-login-link">
              Sign in
            </Link>
          </div>
        </div>

        <div className="mt-8 text-center">
          <Link to="/" className="text-xs uppercase tracking-[0.3em] text-white/40 hover:text-white" data-testid="register-back-home">
            ← Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}
